import React from "react";
import aboutImg from "../../assets/images/aboutgrp.png";

const About = () => {
  return (
    <div className="flex overflow-hidden mx-auto max-w-screen-2xl items-center justify-center">
      <div className="py-6 sm:py-20 mx-4 sm:mx-12 flex flex-col md:flex-row gap-5 sm:gap-10 justify-center items-center">
        <div className="">
          <img src={aboutImg} alt="" />
        </div>
        <div className="flex flex-col gap-4">
          <h3 className="jost-regular text-xl sm:text-2xl text-primary py-4 uppercase">
            About psyche ethos
          </h3>
          <h1 className="jost-regular text-3xl sm:text-5xl max-w-xl">
            Laila Khan: Integrating and Resiliently Changing Lives,
            Organizations,
            <span className="italic font-eiko-thin text-primary">
              {" "}
              and Communities
            </span>
          </h1>
          <p className="max-w-2xl opacity-50">
            Before starting Psyche Ethos, Laila Khan had a successful career in
            financial services. She is now an established consultant, advisor,
            personal mentor, and inspirational speaker. Supporting people,
            groups, and communities in recognizing and removing obstacles to a
            comprehensive synthesis of thoughts, physique, and spirit is her
            aim. Laila promotes this equilibrium in order to create more
            resilient, healthier, and peaceful surroundings as well as long-term
            remedies for well-being on both a personal and a community basis.
            <br />
            <br />
            Laila has demonstrated endurance and adaptation in her career,
            juggling challenging, high-stakes C-suite positions with a vibrant
            family life. Whether in new jobs or during times of organizational
            and social transition, she has thrived in high-pressure settings,
            navigating through uncertainty and transition.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
